const config7={
  header: ['<span style="color:#37a2da;">类型</span>', '<span style="color:#37a2da;">描述</span>', '<span style="color:#37a2da;">状态</span>', '<span style="color:#37a2da;">时间</span>'],
  headerBGC: '#0000FF20', 
  oddRowBGC: 'transparent',    //奇数行背景色
  evenRowBGC: 'transparent', 
  rowNum :6,
  columnWidth: [140, 250, 140, 160],
  align: 'center',
  data: [
    ['维修', '充电桩倾斜到扶正', '已完成', '6.30 14:23',],
    ['保养', '充电桩日常检修', '进行中', '6.18 16:20',],
    ['维修', '充电桩插上电没反应', '进行中', '6.26 11:53',],
    ['保养', '充完电枪拔不出来', '进行中', '6.26 10:23',],
    ['维修', '充电桩外观损伤', '已完成', '6.28 17:28',],
    ['保养', '充电桩插上电没反应', '进行中', '6.30 14:58',],
    ['维修', '充电桩日常检修', '进行中', '6.30 15:43',],
    ['维修', '充电桩倾斜到扶正', '已完成', '6.31 16:23',],
    ['保养', '充电桩插上电没反应', '进行中', '6.31 18:83',],
    ['保养', '充电桩插上电没反应', '已完成', '6.31 19:28',]
  ]
    }
    const config8={
      header: ['<span style="color:#37a2da;">描述</span>', '<span style="color:#37a2da;">状态</span>', '<span style="color:#37a2da;">时间</span>'],
      headerBGC: '#0000FF20', 
      oddRowBGC: 'transparent',    //奇数行背景色
      evenRowBGC: 'transparent', 
      rowNum :14,
      columnWidth: [300, 150,  200],
      align: 'center',
      data: [
        [ '充电订单 ￥36.54', '已完成', '7-5 14:23',],
        [ '充电订单 ￥12.89', '已完成', '7-8 16:20',],
        [ '充电订单 ￥20.54', '已完成', '7-9 11:53',],
        [ '充电订单 ￥9.86', '已完成', '7-10 10:23',],
        [ '充电订单 ￥10.87', '已完成', '7-10 17:28',],
        [ '充电订单 ￥25.89', '已完成', '7-11 14:58',],
        [ '充电订单 ￥80.64', '已完成', '7-11 15:43',],
        [ '充电订单 ￥90.56', '已完成', '7-11 16:23',],
        [ '充电订单 ￥30.24', '已完成', '7-11 18:83',],
        [ '充电订单 ￥35.15', '已完成', '7-11 19:28',],
        [ '充电订单 ￥20.24', '已完成', '7-12 16:83',],
        [ '充电订单 ￥15.15', '已完成', '7-12 17:28',]
      ]
        }
    export {config7,config8}